import { ActionType, TAuthAction, TAuthState } from "../../interfaces/store/authStore";
import { makeStore } from "../makeStore";


const initialState: TAuthState = {
    authData: {
        accessToken: undefined,
        refreshToken: undefined
    },
    user: undefined,
    workspace: undefined,
    context: "individual",
    lifetime: false,
    trial: true,
    validSubscription: false,
    workspaceOwner: false,
    workspaceAdmin: false,
    subscription: undefined,
    userWorkspaces: [],
    disablePremiumFeatures: true,
    inboxTaskId: undefined,
    syncLinkedInContactsTaskId: undefined,
    disconnectedConnectionsCount: 0,
    isLoggedToLinkedin: false,

}

const reducer = (state: TAuthState, action: TAuthAction): TAuthState => {
    switch (action.type) {
        case ActionType.SET_AUTH_DATA: return { ...state, authData: action.payload }
        case ActionType.SET_USER: return { ...state, user: action.payload }
        case ActionType.SET_WORKSPACE: return { ...state, workspace: action.payload }
        case ActionType.SET_CONTEXT: return { ...state, context: action.payload }
        case ActionType.SET_LIFETIME: return { ...state, lifetime: action.payload }
        case ActionType.SET_TRIAL: return { ...state, trial: action.payload }
        case ActionType.SET_VALID_SUBSCRIPTION: return { ...state, validSubscription: action.payload }
        case ActionType.SET_WORKSPACE_OWNER: return { ...state, workspaceOwner: action.payload }
        case ActionType.SET_WORKSPACE_ADMIN: return { ...state, workspaceAdmin: action.payload }
        case ActionType.SET_SUBSCRIPTION : return { ...state, subscription: action.payload }
        case ActionType.SET_USER_WORKSPACES: return { ...state, userWorkspaces: action.payload }
        case ActionType.SET_DISABLE_PREMIUM_FEATURES: return { ...state, disablePremiumFeatures: action.payload }
        case ActionType.SET_INBOX_TASK_ID: return { ...state, inboxTaskId: action.payload }
        case ActionType.SET_SYNC_LINKEDIN_CONTACTS_TASK_ID: return { ...state, syncLinkedInContactsTaskId: action.payload }
        case ActionType.SET_DISCONNECTED_CONNECTIONS_COUNT: return { ...state, disconnectedConnectionsCount: action.payload }
        case ActionType.SET_IS_LOGGED_TO_LINKEDIN: return { ...state, isLoggedToLinkedin: action.payload }
        case ActionType.SET_SCHEDULED_REMOVAL: return { ...state, scheduledRemoval: action.payload }
        case ActionType.SET_VERIFY_EMAIL_REDIRECTED: return { ...state, verifyEmailRedirected: action.payload }
        case ActionType.UPDATE_USER_LAST_FETCH_POSTS_DATE: return { 
            ...state, 
            user: state.user ? { ...state.user, lastFetchPostsDate: action.payload } : state.user 
        }
        case ActionType.RESET_STORE: return { ...initialState }
        default: return state
    }
}

const { StoreProvider: AuthStoreProvider, useStoreContext: useAuthStore } = makeStore(reducer, initialState)

export { AuthStoreProvider, useAuthStore }